import { render, staticRenderFns } from "./ModelInput.vue?vue&type=template&id=236501f6&"
import script from "./ModelInput.vue?vue&type=script&lang=js&"
export * from "./ModelInput.vue?vue&type=script&lang=js&"
import style0 from "./ModelInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports